import { AlertProps as AntdAlertProps } from 'antd';
import React from 'react';
import { withTheme } from '../ThemeProvider';
import { StyledAlert } from './styles';

export type AlertProps = AntdAlertProps & {
  fullWidth?: boolean;
  className?: string;
};

const AlertComponent: React.FC<AlertProps> = ({ fullWidth = false, className, ...props }) => {
  return <StyledAlert {...props} className={className} fullWidth={fullWidth} />;
};

export const Alert = withTheme(AlertComponent);
